module.exports = __webpack_public_path__ + "weathericons-regular-webfont.4618f0de2a818e7ad3fe.ttf";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/weather-icons/fonts/weathericons-regular-webfont.ttf
// module id = ../../../../../src/assets/scss/icons/weather-icons/fonts/weathericons-regular-webfont.ttf
// module chunks = styles